import { defineMessages } from 'react-intl';

export default defineMessages({
  headTitle: {
    id: 'signup.head.title',
    defaultMessage: 'Sign up',
  },
  inviteTitle: {
    id: 'signup.invite.title',
    defaultMessage: 'Sign up to join your team',
  },
  titleNormal: {
    id: 'invitesignup.title.normal',
    defaultMessage: 'We need a few details, to create an account for {email}',
  },
});
